export enum FreeViewStateNames {
  USING_FREEVIEW = 'USING_FREEVIEW',
  TIME_EXPIRED = 'TIME_EXPIRED',
}
